define('responsive-gameday/helpers/JingleAssistant',['require','exports','module','GameDayCore','message-service/message-service','gameday-index-enums/enums/baseball/GameStates','GameDayCore/GDModel/enums/events/EventTypes','../utils/ui-log','extant/extant'],function (require, exports, module) {

	var GDC = require("GameDayCore"),
		MessageService = require('message-service/message-service'),
		GameStates = require("gameday-index-enums/enums/baseball/GameStates"),
		EventTypes = require("GameDayCore/GDModel/enums/events/EventTypes"),
		uilog = require("../utils/ui-log"),
		exists = require("extant/extant");

	var evt = "",
		lastJingleEventName = "";

	exports.init = function($evt) {
		evt = $evt;
		MessageService.addListener(EventTypes.UPDATE, resolveEventName);
	};

	function resolveEventName(payload, alwaysReturn) {
		var linescore = GDC.getGameData("linescore").linescore;
		// Game hasn't started or is over, no jingles
		if(linescore.abstractGameState === GameStates.ABSTRACT_FINAL
			|| linescore.abstractGameState === GameStates.ABSTRACT_PREGAME) {
			return;
		}
		var jfile = null,
			data = GDC.getGameData(),
			eventName = (exists(data, "play.event")) ? data.play.event.toLowerCase() : "";
		if (eventName === lastJingleEventName) {
			// Same event, same fucktastic joy of an atbat, run away
			return;
		} else if (eventName === "" || eventName === "at_bat_start") {
			// No event / new at bat? Reset last event var
			lastJingleEventName = "";
			return;
		}

		// keep track of last event
		lastJingleEventName = eventName;
		uilog.log(eventName);
		switch(eventName) {
			case "walk":
			case "error":
			case "strikeout":
			case "balk":
			case "single":
			case "double":
			case "triple":
			case "extra_innings":
				jfile = eventName;
				break; //the above events all resolve to their input values

			case "home_run":
			case "home run":
				jfile = "hr";
				break;

			case "double_play":
			case "double play":
			case "grounded into dp":
			case "sac fly dp":
			case "caught stealing dp":
			case "base running double play":
			case "strikeout - dp":
				jfile = "double_play";
				break;

			case "triple_play":
			case "triple play":
			case "strikeout - tp":
				jfile = "triple_play";
				break;

			case "pinch hitter":
				jfile = "pinchhit";
				break;

			case "pinch runner":
			case "pinch_runner":
				jfile = "pinch_run";
				break;

			case "pitching_substitution":
			case "pitching substitution":
				jfile = "pitchchange";
				break;

			case "hit_by_pitch":
			case "hit by pitch":
				jfile = "hit_by_pitch";
				break;

			case "wild_pitch":
			case "wild pitch":
				jfile = "wild_pitch";
				break;

			case "stolen_base_2b":
			case "stolen_base_3b":
			case "stolen_base_home":
				jfile = "stolen_base";
				break;

			case "passed_ball":
			case "passed ball":
				jfile = "passed_ball";
				break;

			case "sac_fly":
			case "sac fly":
				jfile = "sacrifice_fly";
				break;

			case "sac_bunt":
			case "sac bunt":
				jfile = "sacrifice_bunt";
				break;

			case "caught_stealing_2b":
			case "caught_stealing_3b":
			case "caught_stealing_home":
			case "pickoff_caught_stealing_2b":
			case "pickoff_caught_stealing_3b":
			case "pickoff_caught_stealing_home":
			case "caught stealing 2b":
			case "caught stealing 3b":
			case "caught stealing home":
			case "pickoff caught stealing 2b":
			case "pickoff caught stealing 3b":
			case "pickoff caught stealing home":
				jfile = "caught_stealing";
				break;

			case "pickoff_1b":
			case "pickoff_2b":
			case "pickoff_3b":
				jfile = "pickoff";
				break;

			default:
				jfile = null;
				break;

		}

		if (jfile !== null) {
			//var jUrl = constructJinglePath(jfile);
			MessageService.publish(evt, jfile);
		}
	}

	function constructJinglePath(jingle) {
		return "/shared/components/gameday/gdapp/release/shared/json/jingles/" + jingle + ".swiffy.json";
	};
});
